import { handleActions } from "redux-actions";

import {
	getCardsListAsyncAction,
	postCardAsyncAction,
	postManyCardsAsyncAction,
	updateCardAsyncAction,
	getCardAsyncAction,
	resetAction,
} from "./cardsActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: defaultAjaxState,
	post_card: defaultAjaxState,
	update_card: defaultAjaxState,
	card_detail: defaultAjaxState,
	post_many_cards: defaultAjaxState,
};

export const cardsReducer = handleActions(
	new Map([
		// get card list
		[
			getCardsListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					loading: true,
				},
			}),
		],
		[
			getCardsListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					response: payload,
				},
			}),
		],
		[
			getCardsListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					error: payload,
				},
			}),
		],

		// post card create
		[
			postCardAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_card: {
					...initialState.post_card,
					loading: true,
				},
			}),
		],
		[
			postCardAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_card: {
					...initialState.post_card,
					response: payload,
				},
			}),
		],
		[
			postCardAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_card: {
					...initialState.post_card,
					error: payload,
				},
			}),
		],

		// post many cards create
		[
			postManyCardsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_many_cards: {
					...initialState.post_many_cards,
					loading: true,
				},
			}),
		],
		[
			postManyCardsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_many_cards: {
					...initialState.post_many_cards,
					response: payload,
				},
			}),
		],
		[
			postManyCardsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_many_cards: {
					...initialState.post_many_cards,
					error: payload,
				},
			}),
		],

		// put card update
		[
			updateCardAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_card: {
					...initialState.update_card,
					loading: true,
				},
			}),
		],
		[
			updateCardAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_card: {
					...initialState.update_card,
					response: payload,
				},
			}),
		],
		[
			updateCardAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_card: {
					...initialState.update_card,
					error: payload,
				},
			}),
		],

		// get card
		[
			getCardAsyncAction.request,
			(state, { payload }) => ({
				...state,
				card_detail: {
					...initialState.card_detail,
					loading: true,
				},
			}),
		],
		[
			getCardAsyncAction.success,
			(state, { payload }) => ({
				...state,
				card_detail: {
					...initialState.card_detail,
					response: payload,
				},
			}),
		],
		[
			getCardAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				card_detail: {
					...initialState.card_detail,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
